export default function Footer() {
  const footerLinks = [
    { label: '首页', href: '#hero' },
    { label: 'APP下载', href: '#app' },
    { label: '焦点推荐', href: '#carousel' },
    { label: '影视图集', href: '#cards' },
    { label: '最新动态', href: '#updates' },
    { label: '联系我们', href: '#contact' },
    { label: '关于我们', href: '#about' },
    { label: '常见问题', href: '#faq' },
  ];

  return (
    <footer id="footer" className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
            <div className="lg:max-w-sm">
              <span className="font-heading font-bold text-2xl text-primary-400">
                7777影院
              </span>
              <p className="mt-4 text-sm text-foreground-100/60 leading-relaxed">
                7777影院汇集最新电影、免费电视剧和热门综艺节目，支持在线不缓冲播放。资源每日更新，高清画质，让你第一时间追剧看电影，享受流畅的在线观影体验。
              </p>
            </div>

            <div className="flex flex-wrap gap-8 lg:gap-16">
              <div>
                <h4 className="font-medium text-sm text-background-50 mb-4">快速导航</h4>
                <ul className="space-y-2.5">
                  {footerLinks.slice(0, 4).map((link) => (
                    <li key={link.href}>
                      <a
                        href={link.href}
                        className="text-sm text-foreground-100/50 hover:text-primary-400 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="font-medium text-sm text-background-50 mb-4">更多链接</h4>
                <ul className="space-y-2.5">
                  {footerLinks.slice(4).map((link) => (
                    <li key={link.href}>
                      <a
                        href={link.href}
                        className="text-sm text-foreground-100/50 hover:text-primary-400 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="font-medium text-sm text-background-50 mb-4">合作伙伴</h4>
                <p className="text-sm text-foreground-100/40 leading-relaxed">
                  合作伙伴信息即将上线
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-100/10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-100/40">
            &copy; {new Date().getFullYear()} 7777影院. 本站内容仅供学习交流，请支持正版。
          </p>
          <p className="text-xs text-foreground-100/30">
            7777影院 | 免费电视剧 | 最新电影 | 综艺节目 | 高清在线观看
          </p>
        </div>
      </div>
    </footer>
  );
}